export const combine7RVenueIdAndExperienceId = (venue) => {
  return venue?.sevenRoomsVenueId + (venue?.experienceId ?? '');
};
